// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__AE-MJ","range":"MonthRangeSwitch_range__VlzVu","disabled":"MonthRangeSwitch_disabled__1M_1n"};